/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3R5bGU9InRyYW5zZm9ybTpyb3RhdGUoMTgwZGVnKSI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS43MSAyLjAwMDA0TDExIDEuMjkwMDRMNC4yOTAwNCA4LjAwMDA0TDExIDE0LjcxTDExLjcxIDE0TDUuNzEwMDQgOC4wMDAwNEwxMS43MSAyLjAwMDA0WiIgZmlsbD0iIzExMTExIi8+PC9zdmc+";